import DebugViewer from './DebugViewer';

export default DebugViewer;
